
/* ZINKE — Galeriebilder vorladen (25.09.2026, Theme 7.8)
   =====================================================

   Anlass: Pascal sah auf der Produktseite der Espressomaschine ein leeres Feld
   mit dem Alt-Text statt des Bildes (Instagram-Browser, Bild 2 von 12).

   Ursache, gemessen am 25.09. mit Chromium gegen die Live-Seite bei 500 kbit/s:
   main-product.liquid rendert alle Medien in die Seite, aber jedes ausser dem
   aktuellen traegt `hidden` und `loading="lazy"`. Ein verstecktes Bild laedt
   der Browser NICHT — der Download startet erst in dem Moment, in dem das
   `hidden` faellt, also beim Blaettern. Gemessen:

     Klick 1 -> weiss.jpg      sichtbar nach 1544 ms  (neu geladen)
     Klick 2 -> g1-modi.jpg    sichtbar nach 2121 ms  (neu geladen)
     Klick 3 -> g2-kapsel.jpg  sichtbar nach 1925 ms  (neu geladen)

   In diesen ein bis zwei Sekunden steht ein leeres Feld da; bricht der Abruf
   ab (Netzwechsel, In-App-Browser), bleibt das Ersatzsymbol mit dem Alt-Text
   stehen — genau das, was Pascal gesehen hat.

   Was hier passiert: die Nachbarbilder werden im Hintergrund geholt, sobald
   die Seite steht, und nach jedem Blaettern die naechsten. Geholt wird mit
   demselben srcset und sizes wie im Markup, damit der Browser dieselbe
   Aufloesung waehlt und der Treffer im Cache landet.

   Sparsam bleibt es durch zwei Grenzen: nur zwei Bilder in jede Richtung,
   und bei „Datensparmodus\" oder 2G gar nicht. Das Markup wird nicht
   angefasst — kein Eingriff in main-product.liquid.

   GEAENDERT 25.09.2026 abends (Theme 7.9, Ladezeit)
   -------------------------------------------------
   Die Nachbarn werden erst geholt, wenn das STARTBILD fertig geladen ist.
   Vorher lief der Vorlader fest 700 ms nach DOMContentLoaded los. Gemessen am
   gedrosselten Handy (1,6 Mbit/s): beim Business-Geschenkset (Startbild
   289 KB) holte er vier weitere Fotos mit zusammen 890 KB, waehrend das
   Startbild noch lud — LCP 8,1 s. Das Startbild ist das Bild der Buehne mit
   fetchpriority="high" (siehe main-product.liquid). Wer vorher blaettert,
   bekommt die Nachbarn wie bisher sofort ueber den Klick-Mithoerer unten.
   Sicherheitsnetz: nach spaetestens 15 s laeuft der Vorlader in jedem Fall. */

(() => {
  'use strict';

  var NACHBARN = 2;
  var geholt = {};

  function sparsam() {
    try {
      var v = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (!v) return false;
      if (v.saveData) return true;
      return /(^|-)2g$/.test(v.effectiveType || '');
    } catch (e) { return false; }
  }

  function vorladen(img) {
    if (!img) return;
    var schluessel = img.getAttribute('srcset') || img.getAttribute('src') || '';
    if (!schluessel || geholt[schluessel]) return;
    geholt[schluessel] = true;
    try {
      var vor = new Image();
      var sizes = img.getAttribute('sizes');
      var srcset = img.getAttribute('srcset');
      var src = img.getAttribute('src');
      if (sizes) vor.sizes = sizes;
      if (srcset) vor.srcset = srcset;
      if (src) vor.src = src;
    } catch (e) {}
  }

  function nachbarn(wurzel) {
    if (sparsam()) return;
    var knoepfe = Array.prototype.slice.call(wurzel.querySelectorAll('[data-thumbnail]'));
    if (knoepfe.length < 2) return;
    var stelle = -1;
    for (var i = 0; i < knoepfe.length; i++) {
      if (knoepfe[i].getAttribute('aria-pressed') === 'true') { stelle = i; break; }
    }
    if (stelle < 0) stelle = 0;
    for (var n = 1; n <= NACHBARN; n++) {
      [stelle + n, stelle - n].forEach(function (z) {
        var ziel = ((z % knoepfe.length) + knoepfe.length) % knoepfe.length;
        var id = knoepfe[ziel] && knoepfe[ziel].getAttribute('data-thumbnail');
        if (!id) return;
        var buehne = wurzel.querySelector('[data-media-id="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"] img');
        vorladen(buehne);
      });
    }
  }

  function alleWurzeln() {
    Array.prototype.slice.call(document.querySelectorAll('[data-product-root]')).forEach(nachbarn);
  }

  /* NICHT auf `load` warten: auf der Produktseite bleibt document.readyState
     auch nach 14 Sekunden auf „interactive" (Drittskripte laden laufend nach),
     das load-Ereignis kommt nie. Die erste Fassung dieses Vorladers hing an
     `load` und lief deshalb gar nicht.

     7.9: gewartet wird stattdessen auf das Startbild selbst. */
  function startbilder() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-product-root] img[fetchpriority="high"]')
    );
  }

  function wennStartbildFertig(weiter) {
    var offen = startbilder().filter(function (img) { return !img.complete; });
    if (!offen.length) { weiter(); return; }
    var erledigt = false;
    var rest = offen.length;
    function fertig() {
      if (erledigt) return;
      erledigt = true;
      weiter();
    }
    offen.forEach(function (img) {
      function eins() {
        img.removeEventListener('load', eins);
        img.removeEventListener('error', eins);
        rest -= 1;
        if (rest <= 0) fertig();
      }
      img.addEventListener('load', eins);
      img.addEventListener('error', eins);
    });
    setTimeout(fertig, 15000);
  }

  function starten() {
    wennStartbildFertig(function () {
      setTimeout(function () {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(alleWurzeln, { timeout: 1200 });
        } else {
          alleWurzeln();
        }
      }, 300);
    });
  }

  /* Nach jedem Blaettern die naechsten Nachbarn nachziehen. Der Klick wird
     nicht abgefangen, nur mitgehoert — daher capture:false und ein kurzer
     Aufschub, damit aria-pressed schon umgesetzt ist. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    if (!t.closest('[data-thumbnail], [data-galerie-vor], [data-galerie-zurueck]')) return;
    var wurzel = t.closest('[data-product-root]');
    if (!wurzel) return;
    setTimeout(function () { nachbarn(wurzel); }, 60);
  });

  document.addEventListener('zinke:variant:change', function () { setTimeout(alleWurzeln, 60); });
  document.addEventListener('shopify:section:load', function () { setTimeout(alleWurzeln, 60); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }
})();
